import { memo } from "react";
import Icon from "core/assets/icons";
import { useAuthModal } from "core/context";

export type IProps = {
  id?: number,
  commentCount?: number,
  handleClickComment?: (e:any) => void,
  className?: string;
};

const CCommentIcon = ({
  id,
  className,
  commentCount = 0,
  handleClickComment,
}: IProps) => {
  const { openModal, token } = useAuthModal();

  const _handleClick = () => {
    if (handleClickComment) {
      if (!token) {
        openModal(() => {
          handleClickComment?.(id);
        });
        return;
      }
      
      handleClickComment?.(id)
    }
  };

  return (
    <>
      <span
          className={`flex items-center ${className}`}
          onClick={_handleClick}
          id={`CCommentIcon-${id}`}
        >
          <img className="mr-[5px]" src={Icon.Comment} alt={'Comment'} />
          <label className={`text-[11px] text-[#333333]`}>
            {commentCount}
          </label>
        </span>
    </>
  );
};


export default memo(CCommentIcon);
